module.exports = "./img/24f77f2c1b9d23148d8c76c959aa8bcd.png";